import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './Wishlist';

const WishlistSuspense = dynamic(() => import('./Wishlist'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicWishlist(props: Props) {
	return <WishlistSuspense {...props} />;
}
DynamicWishlist.displayName = 'DynamicWishlist';
